/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::93c731f584b0c77804f9e9ffcdaba4e6>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "VideoWatchLaterSaved".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-watch-later-saved
 * Usage guidance:
 * Reserved for watch later functionality in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const VideoWatchLaterSavedIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "VideoWatchLaterSavedIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.174.96 1.152.961-3.333 4a.75.75 0 0 1-1.152 0l-1.667-2 1.152-.96 1.09 1.309zM5 2.505a.5.5 0 0 0-.5.5v9.802l3.067-2.165a.75.75 0 0 1 .867 0l3.066 2.174V8.004H13v6.213a.775.775 0 0 1-1.22.634l-.003-.002-3.778-2.677-3.777 2.667H4.22A.775.775 0 0 1 3 14.205V3.004a2 2 0 0 1 2-2h2.25v1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
VideoWatchLaterSavedIcon.displayName = 'VideoWatchLaterSavedIcon';
var _default = exports.default = VideoWatchLaterSavedIcon;